import Http from "../controllers/Http";

export default class FaturaEmbalagemService {

    static urlBase = "/faturaEmbalagem/";

    static getOneById(id, fnSucess = () => { }, fnError = () => { }) {
        Http.getInstanceAppJson()
            .get(this.urlBase + id)
            .then(fnSucess)
            .catch(fnError);
    }

    static create(data, fnSucess = () => { }, fnError = () => { }) {
        Http.getInstanceAppJson()
            .post(this.urlBase, data)
            .then(fnSucess)
            .catch(fnError);
    }

    static update(id, data, fnSucess = () => { }, fnError = () => { }) {
        Http.getInstanceAppJson()
            .post(this.urlBase + id, data)
            .then(fnSucess)
            .catch(fnError);
    }

    static save(data, fnSucess = () => { }, fnError = () => { }) {
        if (data.idFaturaEmbalagem) {
            this.update(data.idFaturaEmbalagem, data, fnSucess, fnError);
        } else {
            this.create(data, fnSucess, fnError);
        }
    }

}
